import { BaseService } from '../base';

export type CapitalGlobalReferenceTableName = 'CNAE' | 'BusinessSegment';

export type CapitalGlobalReferenceDataItem = {
  code: string;
  description: string;
};

export type CapitalGlobalReferenceDataResponse = {
  tableName: CapitalGlobalReferenceTableName;
  data: CapitalGlobalReferenceDataItem[];
  meta: {
    pageNumber: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
};

export type GetCapitalGlobalReferenceDataParams = {
  tableName: CapitalGlobalReferenceTableName;
  filter?: string;
  pageNumber?: number;
  pageSize?: number;
};

export class CapitalGlobalReferenceDataService extends BaseService {
  async getReferenceData(params: GetCapitalGlobalReferenceDataParams): Promise<{
    success: boolean;
    data?: CapitalGlobalReferenceDataResponse;
    error?: string;
  }> {
    try {
      const queryParams = new URLSearchParams({
        tableName: params.tableName,
        pageNumber: String(params.pageNumber ?? 1),
        pageSize: String(params.pageSize ?? 50),
      });

      const trimmedFilter = params.filter?.trim();
      if (trimmedFilter) {
        queryParams.set('filter', trimmedFilter);
      }

      const path = `/portal/v1/services/capital-global/reference-data?${queryParams.toString()}`;
      const response = await this.get(path, {}, import.meta.env.VITE_API_URL);

      return await this.handleJsonResponse<CapitalGlobalReferenceDataResponse>(
        response
      );
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar dados de referência',
      };
    }
  }
}

export const capitalGlobalReferenceDataService =
  new CapitalGlobalReferenceDataService();
